import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { ApiService } from "src/app/api.service";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
  selector: "app-manage-general",
  templateUrl: "./manage-general.component.html",
  styleUrls: ["./manage-general.component.scss"]
})
export class ManageGeneralComponent implements OnChanges {
	@Input()
	asset: APIResults.Asset;

	@Output()
	public AssetUpdated = new EventEmitter<APIResults.Asset>();

	public orgConfigs: APIResults.AssetConfig[] = [];

  constructor(private api: ApiService) { }

	async ngOnChanges(): Promise<void> {
		this.orgConfigs = await this.api.GetAssetConfigs(this.asset.organization_id);
  }

	public async UpdateAsset() {
		await this.api.UpdateAsset(this.asset.organization_id, this.asset.asset_id, { asset_name: this.asset.asset_name, asset_type_id: this.asset.asset_type_id, sim_iccid: this.asset.sim_iccid, mac_address: this.asset.mac_address, board_revision: this.asset.board_revision, gonedark_days: this.asset.gonedark_days, gonedark_suspend: this.asset.gonedark_suspend, hidden: this.asset.hidden });
		this.AssetUpdated.emit(this.asset);
	}
}
